'use client';

import { signIn } from 'next-auth/react';
import { useSearchParams } from 'next/navigation';

export default function LoginPage() {
  const searchParams = useSearchParams();
  const callbackUrl = searchParams.get('callbackUrl') || '/';

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0e1116' }}>
      <div style={{ width: 340, background: '#161b22', border: '1px solid #27303b', borderRadius: 16, padding: 32, display: 'flex', flexDirection: 'column', gap: 0 }}>
        {/* Kicker */}
        <div style={{ fontFamily: 'monospace', fontSize: 11, letterSpacing: '.18em', textTransform: 'uppercase', color: '#4f9cff', marginBottom: 16, textAlign: 'center' }}>
          IT DEV · LINE OA
        </div>

        {/* Title */}
        <h1 style={{ fontSize: 22, fontWeight: 700, color: '#e7edf3', textAlign: 'center', marginBottom: 6, letterSpacing: '-.01em' }}>
          LINE OA CHATBOT ADVWS
        </h1>

        {/* Subtitle */}
        <p style={{ fontSize: 13.5, color: '#9aa7b4', textAlign: 'center', marginBottom: 28, lineHeight: 1.5 }}>
          เข้าสู่ระบบด้วยบัญชี LINE ของคุณ
        </p>

        {/* Divider */}
        <div style={{ height: 1, background: '#27303b', marginBottom: 24 }} />

        {/* LINE Login Button */}
        <button
          onClick={() => signIn('line', { callbackUrl })}
          style={{
            width: '100%',
            padding: '12px 0',
            background: '#06c755',
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 15,
            fontWeight: 600,
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 10,
            letterSpacing: '.01em',
          }}
          onMouseEnter={(e) => (e.currentTarget.style.background = '#05a847')}
          onMouseLeave={(e) => (e.currentTarget.style.background = '#06c755')}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12 2C6.477 2 2 6.145 2 11.243c0 4.152 2.592 7.723 6.408 9.355.28.128.236.346.175.488l-.447 1.73c-.07.27.097.274.204.2 1.23-.748 6.628-3.906 9.097-6.784C18.99 14.37 20 12.878 20 11.243 20 6.145 17.523 2 12 2z"/>
          </svg>
          Login with LINE
        </button>
      </div>
    </div>
  );
}
